import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { TechnicalManualBusinessService } from '../../business-services/technical-manual.service';


@Injectable({ providedIn: 'root' })
export class EditTechnicalManualGuard  {

  constructor(
    private technicalManualService: TechnicalManualBusinessService,
    private router: Router
  ) { }

  canActivate(): Promise<UrlTree | boolean> | Observable<UrlTree | boolean> | UrlTree | boolean {
    if (this.technicalManualService.technicalManualId) {
      return true;
    }
    return this.router.createUrlTree(['/technicalManual']);
  }
}
